import {
  CreateFileFromTemplateDto,
  FileMetaDataDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { DOMAIN_ONLY_OFFICE } from "../domain";

import { onlyOfficeApi } from "@api/services";
import { ACTION_GET_FOLDER, DOMAIN_FOLDERS, roleGuard } from "@api";

export const ACTION_CREATE_FILE_FROM_TEMPLATE = "CREATE_FILE_FROM_TEMPLATE";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const createFileFromTemplate = async (
  params: CreateFileFromTemplateDto,
): Promise<FileMetaDataDto> => {
  const response =
    await onlyOfficeApi.onlyOfficeControllerCreateFileFromTemplate(params);

  return response.data;
};

export const useCreateFileFromTemplate = (
  user: UserProfileDto | null,
): {
  createFileFromTemplateAsync: UseMutateAsyncFunction<
    FileMetaDataDto,
    Error,
    CreateFileFromTemplateDto,
    unknown
  >;
  createFileFromTemplateEnabled: boolean;
  isSuccesscreateFileFromTemplate: boolean;
  isPendingcreateFileFromTemplate: boolean;
} => {
  const queryClient = useQueryClient();

  const enabled = roleGuard(user, allowedRoles);
  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_ONLY_OFFICE, ACTION_CREATE_FILE_FROM_TEMPLATE],
    mutationFn: enabled ? createFileFromTemplate : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FOLDERS, ACTION_GET_FOLDER],
      });
    },
  });

  return {
    createFileFromTemplateAsync: mutateAsync,
    createFileFromTemplateEnabled: enabled,
    isSuccesscreateFileFromTemplate: isSuccess,
    isPendingcreateFileFromTemplate: isPending,
  };
};
